import { logAPI } from "./andyliticsApi";
import ASCClient, { CommunityRepository, PostRepository, ApiEndpoint, ApiRegion, FeedType, CommentRepository } from '@amityco/js-sdk';

const apiKey = typeof window !== 'undefined' ? window.serverData.data.amityApiKey : '';
const apiBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiBaseUrl : '';
const apiTeamAmityBaseUrl = typeof window !== 'undefined' ? window.serverData.data.apiTeamAmityBaseUrl : '';
const communityId = typeof window !== 'undefined' ? window.serverData.data.amityCommunityId : '';
const prayerCommentsMaxLimit = typeof window !== 'undefined' ? window.serverData.data.prayerCommentsMaxLimit : 50;

//const apiEndpoint = ApiEndpoint.US;
const apiRegion = ApiRegion.US;

//export const client = new ASCClient({ apiKey, apiEndpoint });
export const client = new ASCClient({ apiKey, apiRegion });

export const getAmityToken = (userToken) => {
    const url = `${apiTeamAmityBaseUrl}/api/AmityAuthToken`;
    logAPI("Api.PrayerFeature.AmityToken.Get", new Date(), url, userToken);
    return fetch2(url, userToken, '', 'GET', '', true).then(response => {
        const isSuccess = typeof response === 'string' && response.trim().length > 0;
        logAPI('Api.PrayerFeature.AmityToken.Get.' + (isSuccess ? 'Success' : 'Failure'), new Date(), url, response);
        return response;
    }).catch(err => {
        logAPI("Api.PrayerFeature.AmityToken.Get.Failure", new Date(), url, err);
        return err;
    });
};

export const linkAmityAccount = (userToken, userName) => {
    const url = `${apiBaseUrl}v3/HealthSource/Registration/LinkAmityAccount?userName=${userName}`;
    logAPI('Api.PrayerFeature.LinkAmityAccount.Post', new Date(), url, userToken);
    return fetch2(url, userToken, '', 'POST').then(response => {
        const isSuccess = response && response.features && response.features.filter(f => f.key === 'amity')[0].memberId;
        logAPI('Api.PrayerFeature.LinkAmityAccount.Post.' + (isSuccess ? 'Success' : 'Failure'), new Date(), url, response);
        return response;
    }).catch(err => {
        logAPI("Api.PrayerFeature.LinkAmityAccount.Post.Failure", new Date(), url, err);
        return err;
    });
};

export const registerSession = (userId, authToken) => {
    client.registerSession({ userId, authToken });
    return client;
};

export const joinCommunity = () => {
    return CommunityRepository.joinCommunity(communityId);
};

export const queryAllPosts = () => {
    return PostRepository.queryCommunityPosts({
        communityId: communityId,
        feedType: FeedType.Published,
    })
};

export const getPost = postId => {
    return PostRepository.postForId(postId);
};

export const queryMyPosts = (memberId) => {
    return PostRepository.queryCommunityPosts({
        communityId: communityId,
        feedType: FeedType.Published,
        tags: [memberId]
    })
};

export const postPrayer = (textInput, memberId) => {
    try {
        return new Promise((resolve, reject) => {
            const liveObject = PostRepository.createTextPost({
                targetId: communityId,
                targetType: 'community',
                text: JSON.stringify(textInput),
                tags: [memberId]
            })
            liveObject.once('dataUpdated', data => {
                resolve(data);
                liveObject.dispose();
            });
            liveObject.once('dataError', error => {
                reject(error);
                liveObject.dispose();
            });
        });
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};

export const editPost = (postId, textInput, memberId) => {
    try {
        return new Promise((resolve, reject) => {
            const editPostLiveObject = PostRepository.updatePost({
                postId,
                data: { text: JSON.stringify(textInput) },
                tags: [memberId],
                metadata: { edited: 'true' }
            }).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error);
            });
            //editPostLiveObject.on('dataUpdated', data => {
            //    resolve(data);
            //    editPostLiveObject.dispose();
            //});
            //editPostLiveObject.on('dataError', error => {
            //    reject(error);
            //    editPostLiveObject.dispose();
            //});
        });
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};

export const deletePrayer = (postId) => {
    try {
        const response = PostRepository.deletePost(postId, true);
        return response;
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};

export const addReaction = (postId) => {
    const response = PostRepository.addReaction({ postId, reactionName: 'love' });
    return response;
};

export const removeReaction = (postId) => {
    const response = PostRepository.removeReaction({ postId, reactionName: 'love' });
    return response;
};

export const queryAllComments = (postId) => {
    const liveCollection = CommentRepository.queryComments({
        referenceType: 'post',
        referenceId: postId,
        isDeleted: false,
        first: prayerCommentsMaxLimit
    });
    liveCollection.timestamp = new Date();
    return liveCollection;
};

export const getComment = commentId => {
    const liveObject = CommentRepository.commentForId(commentId);
    return liveObject;
};

export const addComment = (comment, postId, postUserIdForNotification) => {
    try {
        return new Promise((resolve, reject) => {
            const payload = { referenceType: 'post', referenceId: postId, text: comment };
            if (postUserIdForNotification) {
                payload.metadata = { postUserIdForNotification };
            }
            const liveObject = CommentRepository.createTextComment(payload);
            liveObject.once('dataUpdated', data => {
                resolve(data);
                liveObject.dispose();
            });
            liveObject.once('dataError', error => {
                reject(error);
                liveObject.dispose();
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const editComment = (commentId, textInput) => {
    try {
        return new Promise((resolve, reject) => {
            const liveObject = CommentRepository.editTextComment({
                commentId: commentId,
                text: textInput,
            });
            liveObject.once('dataUpdated', data => {
                resolve(data);
                liveObject.dispose();
            });
            liveObject.once('dataError', error => {
                reject(error);
                liveObject.dispose();
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteComment = (commentId) => {
    const response = CommentRepository.deleteComment(commentId, true);
    return response;
};

export const addCommentReaction = (commentId) => {
    try {
        return new Promise((resolve, reject) => {
            CommentRepository.addReaction({
                commentId, reactionName: 'love'
            }).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const removeCommentReaction = (commentId) => {
    try {
        return new Promise((resolve, reject) => {
            CommentRepository.removeReaction({
                commentId, reactionName: 'love'
            }).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getNotificationBadge = (userToken) => {
    const url = `${apiTeamAmityBaseUrl}/api/GetNotificationBadge`;
    const params = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'authorization': `bearer ${userToken}`
        }
    };
    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            return response.json();
        } else {
            return '';
        }
    }).catch(err => {
        return err;
    });
};

export const markNotificationBadgeAsRead = (userToken) => {
    const url = `${apiTeamAmityBaseUrl}/api/MarkNotificationBadgeAsRead?IsRead=true`;
    const params = {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'authorization': `bearer ${userToken}`
        }
    };
    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            return response.json();
        } else {
            return '';
        }
    }).catch(err => {
        return err;
    });
};

export const getDeletedPosts = (userToken) => {
    const url = `${apiTeamAmityBaseUrl}/api/GetDeletedPosts`;
    const params = {
        method: 'GET',
        headers: {
            'accept': 'application/json',
            'authorization': `bearer ${userToken}`
        }
    };
    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            return response.json();
        } else {
            return '';
        }
    }).catch(err => {
        return Promise.reject(err);
    });
};

export const markDeletedPostsAsRead = (userToken) => {
    const url = `${apiTeamAmityBaseUrl}/api/MarkDeletedPostsAsRead`;
    const params = {
        method: 'POST',
        headers: {
            'accept': 'application/json',
            'authorization': `bearer ${userToken}`
        }
    };
    return fetch(url, params).then(response => {
        if (response.status >= 200 && response.status < 300) {
            return response.json();
        } else {
            return '';
        }
    }).catch(err => {
        return err;
    });
};